{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Activat",
          "DISABLED": "Dezactivat"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Trimis de",
          "BOT": "Bot",
          "FROM": "de la",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "Renunță",
        "CREATE_BUTTON_TEXT": "Creeaza",
        "FORM": {
          "TITLE": {
            "LABEL": "Titlu",
            "PLACEHOLDER": "Vă rugăm să introduceţi titlul campaniei",
            "ERROR": "Titlul este necesar"
          },
          "MESSAGE": {
            "LABEL": "Mesaj",
            "PLACEHOLDER": "Vă rugăm să introduceți mesajul campaniei",
            "ERROR": "Este necesar un mesaj"
          },
          "INBOX": {
            "LABEL": "Selectați Inbox",
            "PLACEHOLDER": "Selectați Inbox",
            "ERROR": "Inbox-ul este necesar"
          },
          "SENT_BY": {
            "LABEL": "Trimis de",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Expeditorul este necesar"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Vă rugăm să introduceți adresa URL",
            "ERROR": "Te rog introdu un URL valid",
            "URL_IS_REGEXP": "Valoarea este o expresie regulată"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Timp pe pagina (secunde)",
            "PLACEHOLDER": "Vă rugăm să introduceţi timpul",
            "ERROR": "Timpul pe pagină este necesar"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Activați campania",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Declanşator doar în timpul orelor de lucru"
          },
          "BUTTONS": {
            "CREATE": "Creeaza",
            "CANCEL": "Renunță"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "A apărut o eroare. Te rugăm să încerci din nou."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "A apărut o eroare. Te rugăm să încerci din nou."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Finalizată",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "Renunță",
        "CREATE_BUTTON_TEXT": "Creeaza",
        "FORM": {
          "TITLE": {
            "LABEL": "Titlu",
            "PLACEHOLDER": "Vă rugăm să introduceţi titlul campaniei",
            "ERROR": "Titlul este necesar"
          },
          "MESSAGE": {
            "LABEL": "Mesaj",
            "PLACEHOLDER": "Vă rugăm să introduceți mesajul campaniei",
            "ERROR": "Este necesar un mesaj"
          },
          "INBOX": {
            "LABEL": "Selectați Inbox",
            "PLACEHOLDER": "Selectați Inbox",
            "ERROR": "Inbox-ul este necesar"
          },
          "AUDIENCE": {
            "LABEL": "Audienţă",
            "PLACEHOLDER": "Selectați etichetele clienților",
            "ERROR": "Audienţa este necesară"
          },
          "SCHEDULED_AT": {
            "LABEL": "Timp programat",
            "PLACEHOLDER": "Vă rugăm să selectaţi un tip",
            "ERROR": "Timpul programat este necesar"
          },
          "BUTTONS": {
            "CREATE": "Creeaza",
            "CANCEL": "Renunță"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "A apărut o eroare. Te rugăm să încerci din nou."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Sigur doriți să ștergeți?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Şterge",
      "API": {
        "SUCCESS_MESSAGE": "Campanie ștearsă cu succes",
        "ERROR_MESSAGE": "A apărut o eroare. Te rugăm să încerci din nou."
      }
    }
  }
}
